import { sendSignInLinkToEmail } from "firebase/auth";

import { getFirebaseAuth } from "../firebase/firebaseService";
import { generateValidUrl } from "./getValidUrl";

/**
 * Send a passwordless sign-in (magic) link to the given email.
 *
 * Always uses the Firebase client SDK. Under unified-auth the server-side
 * branded-email endpoint (`/magic-link-signup`) is gated by
 * `@require_service_identity`, so it only accepts service-type tokens. The
 * browser never holds a service token — and holds no token at all before login
 * — so it cannot call that endpoint. The client SDK talks directly to Firebase
 * Auth, needs no backend token, and works in every environment whose domain is
 * authorised in Firebase Auth.
 *
 * @param email - Recipient email address.
 * @returns True when the link was sent successfully, false otherwise.
 */
export const sendMagicLinkViaEmail = async (
  email: string,
): Promise<boolean> => {
  const actionCodeSettings = {
    url: generateValidUrl(),
    handleCodeInApp: true,
  };

  try {
    await sendSignInLinkToEmail(getFirebaseAuth(), email, actionCodeSettings);
    window.localStorage.setItem("emailForSignIn", email);
    return true;
  } catch (error) {
    console.error("Error sending magic link:", error);
    return false;
  }
};
